<template>
    <div :class="containerClass" @click="onDocumentClick($event)">
        <Toast class="highest-index" />
        <!-- <Toast :baseZIndex="20000" :autoZIndex="false" /> -->
        <ConfirmDialog />
        <ConfirmDialog group="continue-confirmation">
            <template #message="slotProps">
                <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
                    <i :class="slotProps.message.icon" class="text-6xl text-primary-500"></i>
                    <p>{{ slotProps.message.message }}</p>
                </div>
            </template>
        </ConfirmDialog>
        <ConfirmPopup group="popup" />
        <GlobalLoader />
        <AppTopBar :topbarTheme="topbarTheme" :activeTopbarItem="activeTopbarItem" @menu-button-click="onMenuButtonClick($event)" @right-panel-click="onRightPanelButtonClick" @topbar-item-click="onTopbarItemClick"></AppTopBar>
        <!-- @search-click="onSearchClick" -->

        <div class="menu-wrapper" @click="onMenuClick($event)">
            <AppMenu :active="menuActive" :mobileMenuActive="staticMenuMobileActive" :menuMode="menuMode" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"></AppMenu>
        </div>

        <div class="layout-main">
            <AppBreadcrumb></AppBreadcrumb>

            <div class="layout-content">
                <router-view> </router-view>
            </div>

            <AppFooter></AppFooter>
        </div>

        <!-- <AppConfig
        v-model:theme="theme"
        v-model:layoutMode="layoutMode"
        v-model:menuMode="menuMode"
        v-model:menuTheme="menuTheme"
        v-model:topbarTheme="topbarTheme"
        :configActive="configActive"
        :configClick="configClick"
        @config-click="onConfigClick"
        @config-button-click="onConfigButtonClick"
        ></AppConfig>-->

        <div v-if="staticMenuMobileActive" class="layout-mask modal-in"></div>
    </div>
</template>

<script>
import EventBus from '@/utilities/event-bus';
import AppTopBar from '@/components/AppTopbar';
import AppMenu from '@/components/AppMenu';
import AppFooter from '@/components/AppFooter';
// import AppConfig from '@/components/AppConfig';
import AppBreadcrumb from '@/components/AppBreadcrumb';
import GlobalLoader from '@/components/GlobalLoader.vue';
import { mapStores } from 'pinia';
import { useAuthStore } from '@/modules/auth/store';

export default {
    data() {
        return {
            theme: 'denim',
            topbarTheme: 'light',
            menuTheme: 'dim',
            layoutMode: 'light',
            menuMode: 'static',
            activeTopbarItem: null,
            menuActive: false,
            overlayMenuActive: false,
            staticMenuDesktopInactive: false,
            staticMenuMobileActive: false,
            menuClick: false,
            searchActive: false,
            searchClick: false,
            userMenuClick: false,
            topbarMenuActive: false,
            rightPanelClick: false,
            rightPanelActive: false,
            configActive: false,
            configClick: false,
        };
    },
    computed: {
        containerClass() {
            return [
                'layout-wrapper',
                {
                    'layout-overlay': this.menuMode === 'overlay',
                    'layout-static': this.menuMode === 'static',
                    'layout-horizontal': this.menuMode === 'horizontal',
                    'layout-overlay-active': this.overlayMenuActive,
                    'layout-mobile-active': this.staticMenuMobileActive,
                    'layout-static-active': !this.staticMenuDesktopInactive && this.menuMode === 'static',
                    'layout-rightpanel-active': this.rightPanelActive,
                    'layout-rtl': this.$appState.isRTL,
                    'p-input-filled': this.$primevue.config.inputStyle === 'filled',
                    'p-ripple-disabled': !this.$primevue.config.ripple,
                },
                'layout-menu-' + this.menuTheme + ' layout-topbar-' + this.topbarTheme,
            ];
        },
        ...mapStores(useAuthStore),
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        },
    },
    mounted() {
        // add event listeners to update lastActive state for session timeout
        document.addEventListener('mousemove', this.updateLastActive);
        document.addEventListener('keydown', this.updateLastActive);
        document.addEventListener('click', this.updateLastActive);
    },
    beforeUnmount() {
        // remove event listeners
        document.removeEventListener('mousemove', this.updateLastActive);
        document.removeEventListener('keydown', this.updateLastActive);
        document.removeEventListener('click', this.updateLastActive);
    },
    methods: {
        updateLastActive() {
            this.authStore.setLastActive(Date.now());
        },
        onDocumentClick() {
            if (!this.searchClick) {
                this.searchActive = false;
            }

            if (!this.topbarItemClick) {
                this.activeTopbarItem = null;
                this.topbarMenuActive = false;
            }

            if (!this.userMenuClick) {
                this.topbarMenuActive = false;
            }

            if (!this.rightPanelClick) {
                this.rightPanelActive = false;
            }

            if (!this.menuClick) {
                if (this.isHorizontal()) {
                    EventBus.emit('reset-active-index');
                    this.menuActive = false;
                }

                if (this.overlayMenuActive || this.staticMenuMobileActive) {
                    this.hideOverlayMenu();
                }

                this.unblockBodyScroll();
            }

            if (this.configActive && !this.configClick) {
                this.configActive = false;
            }

            this.searchClick = false;
            this.configClick = false;
            this.topbarItemClick = false;
            this.rightPanelClick = false;
            this.menuClick = false;
        },
        onMenuClick() {
            this.menuClick = true;
        },
        onMenuButtonClick(event) {
            this.rotateMenuButton = !this.rotateMenuButton;
            this.topbarMenuActive = false;
            this.menuClick = true;

            if (this.isOverlay() && !this.isMobile()) {
                this.overlayMenuActive = !this.overlayMenuActive;
            }

            if (this.isDesktop()) {
                this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            } else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
                if (this.staticMenuMobileActive) {
                    this.blockBodyScroll();
                } else {
                    this.unblockBodyScroll();
                }
            }

            event.preventDefault();
        },
        onMenuItemClick(event) {
            if (!event.item.items) {
                EventBus.emit('reset-active-index');
                this.hideOverlayMenu();
            }
            if (!event.item.items && this.isHorizontal()) {
                this.menuActive = false;
            }
        },
        onRootMenuItemClick() {
            this.menuActive = !this.menuActive;
        },
        onRightPanelClick() {
            this.rightPanelClick = true;
        },
        onRightPanelButtonClick(event) {
            this.rightPanelClick = true;
            this.rightPanelActive = !this.rightPanelActive;
            event.preventDefault();
        },
        onTopbarItemClick(event) {
            this.topbarItemClick = true;

            if (this.activeTopbarItem === event.item) {
                this.activeTopbarItem = null;
            } else {
                this.activeTopbarItem = event.item;
            }

            if (event.item === 'search') {
                this.searchActive = !this.searchActive;
                this.searchClick = !this.searchClick;
            }

            event.originalEvent.preventDefault();
        },
        // onSearchClick(event) {
        //     this.searchClick = true;
        //     event.stopPropagation();
        // },
        onConfigClick() {
            this.configClick = true;
        },
        onConfigButtonClick() {
            this.configActive = !this.configActive;
            this.configClick = true;
        },
        hideOverlayMenu() {
            this.overlayMenuActive = false;
            this.staticMenuMobileActive = false;
            this.unblockBodyScroll();
        },
        blockBodyScroll() {
            if (document.body.classList) {
                document.body.classList.add('blocked-scroll');
            } else {
                document.body.className += ' blocked-scroll';
            }
        },
        unblockBodyScroll() {
            if (document.body.classList) {
                document.body.classList.remove('blocked-scroll');
            } else {
                document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            }
        },
        isTablet() {
            const width = window.innerWidth;
            return width <= 1024 && width > 640;
        },
        isDesktop() {
            return window.innerWidth > 992;
        },
        isMobile() {
            return window.innerWidth <= 640;
        },
        isOverlay() {
            return this.menuMode === 'overlay';
        },
        isStatic() {
            return this.menuMode === 'static';
        },
        isHorizontal() {
            return this.menuMode === 'horizontal';
        },
    },
    components: {
        AppTopBar,
        AppMenu,
        AppFooter,
        // AppConfig,
        AppBreadcrumb,
        GlobalLoader,
    },
};
</script>

<style lang="scss">
@import 'App.scss';
ul.preview-section {
    display: flex;
    flex-direction: column;
    li {
        padding: 1rem 0.5rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
}
.highest-index {
    z-index: 2000 !important;
}
</style>
